<template>
  <div>
    <GlobalCompanySearchDropdown
      :countryCode="'FI'"
      @select="$emit('select', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import GlobalCompanySearchDropdown from "@/components/common/GlobalCompanySearchDropdown.vue";
</script>
